import React from 'react';
import InvoiceValidationFunctional from './components/invoice-validation-list-functional';
import './invoice-validation.scss';

const InvoiceValidation = () => {
	return <InvoiceValidationFunctional />;
};

export default InvoiceValidation;
